<template>
  <div class="name-cell">
    <div class="name" @click.stop='openIssue'>
      {{ displayName }}
    </div>
    <div class="subtitle" v-if="item && displaySubtitle">
      {{ description }}
    </div>
  </div>
</template>

<script>
import { views } from '@/router/constants';
import {
  SET_DETAILED_ISSUES_FOR_CENTRALIZED_VIEW,
  SET_OPEN_DETAILED_ISSUES_POPUP,
} from '@/store/centralizedIssues/actionTypes';
import { mapGetters } from 'vuex';

export default {
  name: 'AdvisedActionNameTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async openIssue() {
      if (this.issuesRoute) {
        const fullIssue = this.centralizedIssues.find(issue => issue.id === this.item.objectId);
        const formattedIssue = {
          id: fullIssue.id,
          date: fullIssue.createdDate,
          name: fullIssue.name,
          tld: fullIssue.tld,
          displayName: fullIssue.displayName,
          asset: fullIssue.asset,
          description: fullIssue.metaData.description || 'N/A',
          severity: fullIssue.severity,
          probability: fullIssue.probability,
          status: fullIssue.status,
          priority: fullIssue.priority,
          cycles: fullIssue.issueCount,
          firstSeen: fullIssue.firstDate,
          lastSeen: fullIssue.lastDate,
          metaData: fullIssue.metaData,
        };
        if (fullIssue) {
          await this.$store.dispatch(SET_OPEN_DETAILED_ISSUES_POPUP, true);
          await this.$store.dispatch(SET_DETAILED_ISSUES_FOR_CENTRALIZED_VIEW, formattedIssue);
          await this.$router.push(this.issuesRoute);
        }
      }
    },
  },
  computed: {
    ...mapGetters(['centralizedIssues']),
    displayName() {
      // For CVE issues, prefer the enrichment display_name which contains the full CVE description
      const enrichmentDisplayName = (this.item.metaData && this.item.metaData.enrichment && this.item.metaData.enrichment.display_name) || '';
      if (enrichmentDisplayName) {
        return enrichmentDisplayName;
      }
      return this.item.displayName || this.item.name;
    },
    displaySubtitle() {
      return this.description.length > 0;
    },
    description() {
      return this.item.description.replace('/tcp', '/TCP');
    },
    issueId() {
      return this.issue.objectId;
    },
    issuesRoute() {
      return { name: views.ISSUES, params: { openDetailedIssuePopupRouteParam: 'true' } };
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/styles/design-system';

.name-cell {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.name{
  z-index: 15;
  align-items: center;
  color: var(--text-primary);
  display: flex;
  font-family: $font-family-bold;
  font-size: rem(14);
  font-weight: bold;
  letter-spacing: 0;
  line-height: rem(17);

  &:hover {
    color: var(--brand-primary);
    cursor: pointer;
  }
}

.subtitle {
  color: var(--text-primary);
  font-family: $font-family-regular;
  font-size: rem(12);
  letter-spacing: 0;
  line-height: rem(15);
  text-transform: capitalize;
  max-width: 98%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
